function fireEvent(name, detail) {
    return document.dispatchEvent(
        new CustomEvent(`notifications:${name}`,  {detail}),
    );
}

let notify = params => {
    if (typeof params === 'string') {
        params = {title: '', text: params}
    }

    if (typeof params === 'object') {
        return fireEvent('push', params);
    }
};

const notifyType = (type, title, params) => {
    if (typeof params === 'string') {
        params = {text: params}
    }

    if (typeof params === 'object') {
        notify(Object.assign({title, type}, params));
    }
};

notify.close = id => fireEvent('close', id);

notify.success = params => notifyType('success', 'Success', params);
notify.warning = params => notifyType('warning', 'Warning', params);
notify.error = params => notifyType('error', 'Error', params);
notify.info = params => notifyType('info', 'Info', params);

export default notify;
